import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { createStyles } from '@material-ui/core/styles';
import { Button, ButtonVariants, FontIcon, Text, withBaseProps, } from '@topconagriculture/react-components';
import * as React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { logout as logoutAction } from '../..';
import withAuth0 from '../../hocs/withAuth0';
const styles = (theme) => createStyles({
    loginButton: {
        marginTop: theme.space.margin.default,
        maxHeight: 50,
    },
    modalWrapper: {
        overflowY: 'auto',
        borderRadius: theme.common.borderRadius.default,
        maxWidth: '90%',
    },
    modalContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: `0 ${theme.space.padding.default}px`,
    },
    textLayout: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginLeft: theme.space.margin.default,
    },
    textTitle: {
        display: 'block',
        marginBottom: theme.space.margin.small,
    },
    infoIcon: {
        marginTop: theme.space.margin.default - 5,
    },
});
const SessionExpiredModal = (props) => {
    const { classes, auth, goToLoginPage, t, theme } = props;
    return !auth.isSessionActive ? (React.createElement(Dialog, { open: !auth.isSessionActive, classes: { paper: classes.modalWrapper }, disableEnforceFocus: true },
        React.createElement(DialogContent, { className: classes.modalContent },
            React.createElement("div", { className: classes.textContainer },
                React.createElement(FontIcon, { iconName: "warning", size: 50, color: theme.color.error.main, className: classes.infoIcon }),
                React.createElement("div", { className: classes.textLayout },
                    React.createElement(Text, { size: 18, bold: true, className: classes.textTitle }, t('common:session_expired')),
                    React.createElement(Text, null, t('common:please_login')))),
            React.createElement(Button, { testId: "go-to-login", className: classes.loginButton, onClick: goToLoginPage, label: t('common:go_to_login'), iconSize: 30, role: ButtonVariants.primary })))) : null;
};
const mapDispatchToProps = (dispatch) => bindActionCreators({
    logout: logoutAction.started,
}, dispatch);
export default compose(connect(null, mapDispatchToProps), withBaseProps({ styles }), withAuth0, withHandlers({
    goToLoginPage: ({ auth, logout }) => () => {
        logout();
        auth.logout();
    },
}))(SessionExpiredModal);
//# sourceMappingURL=SessionExpiredModal.js.map